import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

// Components
import { Screen, SplitScreen, SplitScreenContentHolder } from '../../../components/Layout/Screen';
import {
  AbsolutePositioned,
  BackgroundContainer
} from '../../../components/Layout/AbsolutePositioned';
import TextBlock from '../../../components/TextBlock';
import LineLink from '../../../components/LineLink';

// Assets
import { brandColors, device } from '../../../styles/variables';
import antelope from '../../../assets/images/pages/about/antelope.png';
import clientLogos from '../../../assets/images/RD_Logos_1.png';

const StyledScreen = Screen.extend`
  height: auto;
  padding: 0 0 50px 0;
  background-color: white;
  @media ${device.tablet} {
    height: 100%;
    padding: 0;
  }
`;

const BackgroundSplitScreen = SplitScreen.extend`
  height: 100%;
  position: relative;
`;

const StyledSplitScreen = SplitScreen.extend`
  position: relative;
  display: block;
  width: 100%;
  @media ${device.tablet} {
    display: inline-block;
    width: 50%;
    height: 100%;
  }
`;

const AboutSplitScreenContentHolderOne = SplitScreenContentHolder.extend`
  float: none;
  @media ${device.tablet} {
    float: right;
  }
`;

const AboutSplitScreenContentHolderTwo = SplitScreenContentHolder.extend`
  float: none;
  @media ${device.tablet} {
    float: left;
  }
`;

const TextBlockPostion = AbsolutePositioned.extend`
  top: 200px;
  left: 60px;
`;

const ImgContainer = styled.div`
  max-width: 460px;
  width: 100%;
  position: relative;
  @media ${device.tablet} {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

const BrandImageContainer = styled.div`
  max-width: 390px;
  width: 100%;
  position: relative;
  margin: 0 auto;
  @media ${device.tablet} {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  img {
    width: 100%;
    margin: 5px;
    display: inline-block;
    vertical-align: top;
  }
`;

const LineLinkPosition = styled.div`
  position: absolute;
  right: 16%;
  bottom: 0;
  @media ${device.tablet} {
    bottom: 29px;
    left: 70px;
  }
  @media ${device.laptopL} {
    bottom: 58px;
    left: 70px;
  }
`;

const ClientsScreen = () => (
  <StyledScreen>
    <BackgroundContainer>
      <BackgroundSplitScreen />
      <BackgroundSplitScreen background={brandColors.yellow} />
    </BackgroundContainer>
    <StyledSplitScreen>
      <AboutSplitScreenContentHolderOne direction="right">
        <ImgContainer>
          <img src={antelope} alt="antelope" />
          <TextBlockPostion>
            <TextBlock width="185px">
              <p>
                We&apos;ve been working with our clients for many years and most of our new business
                comes through recommendations.
              </p>
            </TextBlock>
          </TextBlockPostion>
        </ImgContainer>
      </AboutSplitScreenContentHolderOne>
    </StyledSplitScreen>
    <StyledSplitScreen>
      <AboutSplitScreenContentHolderTwo>
        <BrandImageContainer>
          <img src={clientLogos} alt="Client Logos" />
          <TextBlock>
            <p>+ many more</p>
          </TextBlock>
        </BrandImageContainer>
        <LineLinkPosition>
          <LineLink
            linkText="get our creds"
            linkColor={brandColors.orange}
            route="/contact#contactMain"
            lineColor={brandColors.blue}
            active
          />
        </LineLinkPosition>
      </AboutSplitScreenContentHolderTwo>
    </StyledSplitScreen>
  </StyledScreen>
);

export default connect()(ClientsScreen);



// WEBPACK FOOTER //
// ./src/pages/About/screens/Clients.jsx